import React from 'react';
import {Switch, Route} from 'react-router-dom';
import ModalDisplay from '../../components/modal-display';
// import {useBreadcrumbs} from '../../hooks/use-breadcrumbs';
import UsedVehicleDetailPage from '../details-vehicle-page';
import SearchResultsPage from '../search-results-page';

export interface FeatureAppStandaloneProps {
  // Pass props if you need
}

export const FeatureAppStandalone: React.FC = () => {
  // useBreadcrumbs();
  return (
    <>
      <Switch>
        <Route exact path="/">
          <SearchResultsPage />
        </Route>
        <Route exact path="/cpo/vehicle/:vin">
          <UsedVehicleDetailPage />
        </Route>
      </Switch>
      <ModalDisplay />
    </>
  );
};
